import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from 'vue';
import { Placement, Tooltip } from 'floating-vue';
import { VueAttributeClass } from '@/types/attributes-vue';
import { UseDocumentSizeReturn, useDocumentSize } from '@/composables/use-document-size';
import { UseTailwindConfigReturn, useTailwindConfig } from '@/composables/use-tailwind-config';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTooltip',
  props: {
  placement: {
    type: String as PropType<Placement>,
    default: 'top',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  showOnClick: {
    type: Boolean,
    default: false,
  },
  class: {
    type: [String, Object] as PropType<VueAttributeClass>,
    default: 'tooltip:default',
  },
},
  emits: {
  show: null,
},
  setup(__props, { emit }) {

const props = __props;





const tailwindConfig: UseTailwindConfigReturn = useTailwindConfig();
const documentSize: UseDocumentSizeReturn = useDocumentSize();

const distance: number = documentSize.remToRaw(tailwindConfig.getValue('padding', '2.5'));

const triggers: string[] = ['hover', 'focus', 'touch'];

const triggerTooltipShow = (): void => {
  emit('show');
};

if (props.showOnClick) {
  triggers.push('click');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tooltip), {
    container: "#tooltip",
    distance: _unref(distance),
    triggers: triggers,
    placement: props.placement,
    disabled: props.disabled,
    "popper-class": props.class,
    class: "flex",
    "auto-boundary-max-size": "",
    "handle-resize": "",
    onShow: triggerTooltipShow
  }, {
    popper: _withCtx(() => [
      _renderSlot(_ctx.$slots, "popper")
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["distance", "placement", "disabled", "popper-class"]))
}
}

})